// playerscategory.js
import React from "react";
import "./create.css";

function CategoryTabs({ selectedCategory, setSelectedCategory }) {
  const categories = ["WK", "BAT", "AR", "BOW"];

  return (
    <ul className="nav nav-tabs mt-3">
      {categories.map((cat) => (
        <li key={cat} className="nav-item">
          <button
            className={`nav-link ${selectedCategory === cat ? "active" : ""}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </button>
        </li>
      ))}
    </ul>
  );
}

export default CategoryTabs;
